//////// INIT GLOBAL VARS ///////



(function ($) {
  /////// INIT SCOPE VARS //////


  /////////////// ON READY /////////////////
  $(function () {
    init_grids();
  }); // end ready

  ///////////////// INIT FUNCTIONS ////////////////////
  function init_grids() {
    
    $(".isotope-grid").each( function() {
      
      var $grid = $(this);
      var $grid_filter_buttons = get_action_buttons_for_grid( $grid );
      
      $grid.isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer'
        }
      });
      
      $grid_filter_buttons.on( "click", function() {
        var $filter_button = $(this);
        
        $filter_button.parents(".grid-actions").find(".active").removeClass("active");
        $filter_button.addClass("active");
        
        add_filters_form_button( $(this) );
      });
      
      maybe_trigger_click_if_hash_filter_found( $grid );
      
    });
  }
  
  
  /////////////////  FUNCTIONS /////////////////    
  function add_filters_form_button( $filter_button ) {
    var $grid = $filter_button.parents(".grid-actions").siblings(".isotope-grid");
    var new_filter = $filter_button.data("filter");
    
    $grid.isotope({
      filter: new_filter,
    });
  }
  
  function get_action_buttons_for_grid( $grid ) {
    return $grid.siblings(".grid-actions").find(".grid-filter");
  }
  
  function maybe_trigger_click_if_hash_filter_found( $grid ) {
    var hash = location.hash;
    var $filter_buttons = get_action_buttons_for_grid( $grid );
    var $active_filter_button = $filter_buttons.filter("[href$='" + hash + "']");
    
    if( $active_filter_button.length ) {
      $active_filter_button.trigger("click");
    }
  }

})(jQuery); // end conflict sage jQuery

//////////////// GLOBAL FUNCTIONS ///////////////